import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=43d0d621&scoped=true"
import script from "./WizardHeader.vue?vue&type=script&lang=js"
export * from "./WizardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d0d621",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d0d621')) {
      api.createRecord('43d0d621', component.options)
    } else {
      api.reload('43d0d621', component.options)
    }
    module.hot.accept("./WizardHeader.vue?vue&type=template&id=43d0d621&scoped=true", function () {
      api.rerender('43d0d621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wizard/WizardHeader.vue"
export default component.exports